import { User } from "firebase/auth";
import { useEffect, useState } from "react";
import { auth } from "../../auth/firebase";

const useAuthState = () => {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setUser(user);
      setLoading(false);
    });

    // Cleanup on unmount
    return () => {
      unsubscribe();
    };
  }, []);

  return { user, setUser, loading };
};

export default useAuthState;
